/*
Uncomment and edit REWRITE_MAP to redirect selected URLs to USER cloud formation.

const REWRITE_MAP = {
  'https://dev-api.gotolstoy.com/onyou/widget-settings':
    'https://gb862emhwg.execute-api.us-east-1.amazonaws.com/widget-settings',
};

function rewriteUrl(url: string): string {
  for (const [from, to] of Object.entries(REWRITE_MAP)) {
    if (url.includes(from)) {
      return url.replace(from, to);
    }
  }
  return url;
}
*/

export class HttpClientError extends Error {
  public readonly response: Response;
  public readonly data: Record<string, unknown>;
  public readonly statusCode: number;

  constructor(message: string, response: Response, data?: Record<string, unknown>) {
    super(`${message}. ${JSON.stringify(data, null, 2)}`);
    this.response = response;
    this.statusCode = response.status;
    this.data = data ?? {};
  }
}

export class HttpClientClass {
  private authPromiseResolver?: (value: { isLoggedIn: boolean }) => void;
  private authCompletePromise: Promise<{ isLoggedIn: boolean }>;
  private headers: Record<string, string> = {};
  private apiUrl: string;

  constructor(apiUrl: string, accessToken: string = '', headers: Record<string, string> = {}) {
    this.apiUrl = apiUrl;
    this.authCompletePromise = new Promise((resolve) => {
      this.authPromiseResolver = resolve;
    });
    this.headers = {
      ...headers,
      Authorization: accessToken ? `Bearer ${accessToken}` : '',
    };
  }

  onAuthComplete(isLoggedIn: boolean) {
    this.authPromiseResolver?.({ isLoggedIn });
  }

  async get<T>(path: string, urlParams: Record<string, string | undefined | null> = {}): Promise<T> {
    const url = `${this.apiUrl}${this.appendQueryParams(path, urlParams)}`;
    /*
    Uncomment and edit REWRITE_MAP to redirect selected URLs to USER cloud formation.
    url = rewriteUrl(url);
    */
    return this.fetch<T>(url, { method: 'GET' });
  }

  async post<T>(path: string, data: Record<string, unknown>): Promise<T> {
    const url = `${this.apiUrl}${path}`;
    /*
    Uncomment and edit REWRITE_MAP to redirect selected URLs to USER cloud formation.
    url = rewriteUrl(url);
    */
    return this.fetch<T>(url, { method: 'POST', body: JSON.stringify(data) });
  }

  async delete<T>(path: string, urlParams: Record<string, string | undefined | null> = {}): Promise<T> {
    const url = `${this.apiUrl}${this.appendQueryParams(path, urlParams)}`;
    /*
    Uncomment and edit REWRITE_MAP to redirect selected URLs to USER cloud formation.
    url = rewriteUrl(url);
    */
    return this.fetch<T>(url, { method: 'DELETE' });
  }

  async patch<T>(path: string, data: Record<string, unknown>): Promise<T> {
    const url = `${this.apiUrl}${path}`;
    return this.fetch<T>(url, { method: 'PATCH', body: JSON.stringify(data) });
  }

  private appendQueryParams(path: string, urlParams: Record<string, string | undefined | null> = {}): string {
    const filteredUrlParams: Record<string, string> = {};
    for (const [key, value] of Object.entries(urlParams)) {
      if (value !== undefined && value !== null) {
        filteredUrlParams[key] = value;
      }
    }
    if (Object.keys(filteredUrlParams).length === 0) {
      return path;
    }

    return `${path}?${new URLSearchParams(filteredUrlParams).toString()}`;
  }

  private async fetch<T>(url: string, init: RequestInit): Promise<T> {
    try {
      // const { isLoggedIn } = await this.authCompletePromise;
      // if (!isLoggedIn) {
      //   throw new Error('Not logged in');
      // }

      const response = await fetch(url, {
        ...init,
        headers: {
          ...init.headers,
          ...this.headers,
        },
      });

      if (response.status !== 200 && response.status !== 201) {
        const errorData = await response.json();
        throw new HttpClientError(`Failed to fetch data.`, response, errorData);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching data', error);
      throw error;
    }
  }
}
